export function Spinner() {
  return (
    <>
      <div className="wk-spinner">
        <div className="loader"></div>
      </div>
    </>
  );
}
